import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { isTokenExpired, type User } from "@maeiz/core";
import { AUTH_STORAGE_KEY } from "@lib/authKeys";

export interface AuthState {
    user: User | null;
    token: string | null;
    isAuthenticated: boolean;
    setAuth: (user: User, token: string) => void;
    updateUser: (user: User) => void;
    clearAuth: () => void;
    checkTokenExpiry: () => boolean;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set, get) => ({
            user: null,
            token: null,
            isAuthenticated: false,
            setAuth: (user, token) => set({ user, token, isAuthenticated: true }),
            updateUser: (user) => set({ user }),
            clearAuth: () => set({ user: null, token: null, isAuthenticated: false }),
            checkTokenExpiry: () => {
                const { token } = get();
                if (!token || isTokenExpired(token)) {
                    if (token) {
                        set({ user: null, token: null, isAuthenticated: false });
                    }
                    return false;
                }
                return true;
            },
        }),
        {
            name: AUTH_STORAGE_KEY,
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({
                user: state.user,
                token: state.token,
                isAuthenticated: state.isAuthenticated,
            }),
        }
    )
);
